import React from 'react';
import { ArrowUpRightIcon, MailIcon } from 'lucide-react';
import { Logo } from './Logo';
import { quotationMeta } from '../data/quotation';
import { formatEuro } from '../utils/pricing';
interface QuotationFooterProps {
  total: number;
}
export function QuotationFooter({
  total
}: QuotationFooterProps) {
  return <footer className="border-t border-line bg-surface" data-id="element-133" data-mp="yrqxmb80done">
      <div className="mx-auto w-full max-w-7xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-134" data-mp="22jawzvnl9hw">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-135" data-mp="20gadlwvjxyx">
          <div className="max-w-xl" data-id="element-136" data-mp="64e8btagr2qe">
            <Logo height={30} alt="Snakker" data-id="element-137" data-mp="b3hdreucvayw" />
            <h2 className="mt-6 font-display text-3xl font-bold leading-tight tracking-tight text-ink-900" data-id="element-138" data-mp="b1o7w1rkgury">
              Ready to start on Anzupgo, Adtralza and Spevigo?
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink-500" data-id="element-139" data-mp="3ej6ds3ns3rpq">
              We can start the snakification sprint within two weeks of
              sign-off, prioritising the most complex brand site first.
            </p>
            <div className="mt-8 flex flex-wrap gap-4" data-id="element-140" data-mp="1gq4oneljvmnt">
              <a href="mailto:hello@snakker.com?subject=Leo%20Pharma%20quotation%20SNK-LEO-2026-01" className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-141" data-mp="1cnhsx2lrdhlc">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="sy6bsq6gdj8k" />
                Accept and start scoping
              </a>
              <a href="mailto:hello@snakker.com?subject=Questions%20on%20quotation%20SNK-LEO-2026-01" className="inline-flex items-center gap-2 rounded-full border border-ink-900 px-6 py-3 text-sm font-semibold text-ink-900 transition-colors hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-143" data-mp="oxnlj0k7kl8h">
                Ask a question
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="2xeuiolt4ux2v" />
              </a>
            </div>
          </div>

          <dl className="grid w-full gap-6 sm:grid-cols-2 lg:w-auto lg:grid-cols-1 lg:text-right" data-id="element-145" data-mp="328yp93yhl33f">
            <div data-id="element-146" data-mp="2odw9lp3u7zdf">
              <dt className="text-xs uppercase tracking-[0.18em] text-ink-300" data-id="element-147" data-mp="2tekb54pozylw">
                Total year-one investment
              </dt>
              <dd className="mt-2 font-display text-3xl font-bold tracking-tight text-ink-900" data-id="element-148" data-mp="3h5ppfffziiu3">
                {formatEuro(total)}
              </dd>
            </div>
            <div data-id="element-149" data-mp="376qf7sfkmf4z">
              <dt className="text-xs uppercase tracking-[0.18em] text-ink-300" data-id="element-150" data-mp="3755lu64zt28p">
                Quotation valid until
              </dt>
              <dd className="mt-2 text-sm text-ink-700" data-id="element-151" data-mp="3c7egr81feedg">
                {quotationMeta.validUntil}
              </dd>
            </div>
          </dl>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-line pt-8 text-xs text-ink-300 sm:flex-row sm:items-center sm:justify-between" data-id="element-152" data-mp="20r68cpzbc8tv">
          <p data-id="element-153" data-mp="1t8glkqrejmp6">
            Ref {quotationMeta.reference} · Prepared {quotationMeta.preparedOn}{' '}
            for {quotationMeta.client}
          </p>
          <p data-id="element-154" data-mp="22690vux4iuck">All prices in EUR, excluding VAT. Commercial in confidence.</p>
        </div>
      </div>
    </footer>;
}